module.exports = __webpack_public_path__ + "img/vr-bean-bag-toss.08f5683c.png";